import { Avatar, Button, Space, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import "./adminstudent.css";
import { Link } from "react-router-dom";
import Modal from "./Modal";
import Modal1 from "./Modal1";
import Selectbar from "./Selectbar";
import Item from "antd/es/list/Item";
import {
  getAllApplicationTeams,
  updateApplication,
} from "../../HttpRequest/applyapplication";
import { getUserDocuments } from "../../HttpRequest/uploadDocuments";
import defaultImage from "../../../assets/img/profiles/icons8-test-account-90.png";
import { display } from "@mui/system";
import App from "../Reusecomponent/Popup";
import Loading from "../Reusecomponent/Loading";
import { FastField } from "formik";

const { Column } = Table;
export default function Table1({
  applicationsdata,
  teams,
  assigntoTeam,
  parentDataUpdating,
}) {
  const [tabledata, settabledata] = useState([]);
  const [teamsdata, setteamsdata] = useState([]);
  const [loginUserRole, setloginUserRole] = useState("");
  const [userProfileUrl, setUserProfileUrl] = useState([defaultImage]);
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [popupApplicationId, setPopupApplicationId] = useState([]);
  const [loading, setLoading] = useState(false);
  

  const handleOk = () => {
    setPopupVisible(false);
  };

  const handleCancel = () => {
    setPopupVisible(false);
  };

  const [popUp, setpopUp] = useState(false);

  const showModal = (applicationId) => {
    setPopupVisible(true);
    setPopupApplicationId(applicationId);
  };
  const [loginRole, setLoginRole] = useState();
  useEffect(() => {
    const storedRole = sessionStorage.getItem("userRole") || localStorage.getItem("userRole");
    setLoginRole(storedRole);
    let dataToSet = applicationsdata;

    if (applicationsdata && teams) {
      console.log("application->", applicationsdata);
      console.log("team->", teams);
    } else {
      dataToSet = [];
    }

    const updatedDataPromises = dataToSet.map(async (userApplication) => {
      let imageUrl = userApplication.profilePic
        ? await downloadProfile(
            userApplication.userId,
            userApplication.profilePic
          )
        : defaultImage;

      return {
        ...userApplication,
        imageUrl: imageUrl,
      };
    });

    Promise.all(updatedDataPromises)
      .then((updatedApplicationsData) => {
        setLoading(true);
        console.log("updated table data-->", updatedApplicationsData);
        settabledata(updatedApplicationsData);
      })
      .catch((error) => {
        console.error("Error updating data:", error);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });

    if (teams) {
      setteamsdata(teams);
    }
    if (storedRole) {
      setloginUserRole(storedRole);
      console.log("Role is found-->", loginUserRole);
    } else {
      console.log("Role is not found-->");
    }
  }, [applicationsdata,]);

  const downloadProfile = async (userId, key) => {
    console.log("image download method url-->", userId, key);
    const headers = new Headers({ "Content-Type": "application/octet-stream" });
    const options = { headers, responseType: "blob" };
    try {
      const response = await getUserDocuments(userId, key, options);
      console.log("Response from getUserDocuments:", response);
      if (response && response.headers && response.data) {
        const contentType = response.headers["content-type"];
        const blob = new Blob([response.data], { type: contentType });
        if (blob instanceof Blob) {
          // setUserProfileUrl(URL.createObjectURL(blob));
          console.log("after state image ==>", userProfileUrl);
          return URL.createObjectURL(blob);
        } else {
          console.error("Invalid blob data received:", blob);
        }
      } else {
        console.error("Invalid response from getUserDocuments:", response);
        return null;
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };
  const firstDropDownOpen = () => {
    setshowapplicationpending(true);
  };
  const options = [
    "--Select Options--",
    "application-requested",
    "application-pending",
    "admit-received",
    "admit-rejected",
    "process-i-20",
    "i-20-process-completed",
    "i-20-received",
    "ds-160-sevis-pending",
    "ds-160-sevis-completed",
    "visa-slot-booked",
    "visa-processing",
    "visa-received",
    "visa-rejected",
    "case-closed",
  ];
  const optionsForapplicationAssistant = [
    "--Select Options--",
    "application-pending",
    "application-submitted",
    "admit-received",
    "admit-rejected",
    "i-20-process-completed",
    "i-20-received",
    "case-closed",
  ];
  const mainDropdownOptions =
    loginRole === "application-assistant"
      ? optionsForapplicationAssistant
      : options;

  const [tableDataStatus, setTableDataStatus] = useState({});

  const columns = [
    {
      title: "",
      dataIndex: "imageUrl",
      key: "imageUrl",
      render: (imageUrl) => (
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQor3aOtnvdUwbhjT1QMg4k8xSlr7w5yKd2CHeZYmGlGw&s"
          alt="imagesuniverciy"
          className="cardunvercityimage"
        />
      ),
    },
    {
      title: () => (
        <div>
          <p className="mb-0">University Name</p>
          <p>Course Name</p>
        </div>
      ),
      dataIndex: "data",
      key: "name",
      render: (name, data) => (
        <div className="dataline">
          <Link
            to={{
              pathname: "/adminuniversity",
              state: { id: data.masterDataEntityId },
            }}
          >
            {" "}
            <h6>{data.university}</h6>{" "}
          </Link>
          <Link
            to={{
              pathname: "/adminuniversity",
              state: { id: data.masterDataEntityId },
            }}
          >
            {" "}
            <p>{data.name}</p>
          </Link>
        </div>
      ),
    },
    {
      title: "",
      dataIndex: "data",
      key: "avatar",
      render: (avatar, data) => (
        <Link to={{ pathname: "/profile", state: data.userId }}>
          <Avatar src={data.imageUrl} alt="student" className="containerv" />
        </Link>
      ),
    },
    {
      title: "Student_Name",
      dataIndex: "data",
      key: "details",
      render: (details, data) => (
        <div className="dataline">
          <Link to={{ pathname: "/profile", state: data.userId }}>
            <p style={{ fontWeight: "blod" }} className="fw-bold">
              {data.firstName}{" "}
            </p>{" "}
          </Link>
          <Link to={{ pathname: "/profile", state: data.userId }}>
            <p>{data.lastName}</p>{" "}
          </Link>
          {/* <p>{record.lastName} Ma</p> */}
        </div>
      ),
    },
    {
      title: (name) => (
        <div>
          <p className="mb-0">Application_Id</p>
          <p>App. Date</p>
        </div>
      ),
      dataIndex: "contact",
      key: "contact",
      render: (text, data) => (
        <div className="dataline" style={{ marginLeft: "9px" }}>
          <p>{data.applicationId}</p>
          <p> {data.createdDate}</p>
        </div>
      ),
    },
    {
      title: "Intake",
      dataIndex: "data",
      key: "data",
      render: (text, data) => (
        <div style={{ marginLeft: "9px" }}>
          <div>{data.intakes}</div>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, data) => (
        <div key={data.id} className="linecontener">
          <div>
            <select
              className="form-select form-select-sm"
              aria-label="Small select example"
              style={{ border: "1px solid rgba(212, 175, 55, 0.25)", background: "rgba(18, 18, 18, 0.65)", color: "#FFE082", boxShadow: "none" }}
              onChange={(e) => handleFirstDropdownChange(e.target.value, data)}
              value={data.status}
            >
              {mainDropdownOptions.map((option, index) => {
                let matchingIndex = options.indexOf(data.status);

                if (index > matchingIndex + 1) {
                  let isAfterMatchingValue = true;
                  return (
                    <option
                      key={option}
                      value={option}
                      style={{
                        display: isAfterMatchingValue ? "none" : "block",
                      }}
                    >
                      {option}
                    </option>
                  );
                }

                // Continue rendering other options
                return (
                  <option key={option} value={option}>
                    {option}
                  </option>
                );
              })}
            </select>
          </div>

          {data.status == "application-requested" &&
            loginRole != "application-assistant" && (
              <div>
                <select
                  className="form-select form-select-sm"
                  aria-label="Small select example"
                  style={{
                    border: "1px solid rgba(212, 175, 55, 0.25)",
                    background: "rgba(18, 18, 18, 0.65)",
                    color: "#FFE082",
                    boxShadow: "none",
                  }}
                  onChange={(e) =>
                    handleSubStatusDropdownChange(e.target.value, data)
                  }
                  value={data.subStatus}
                >
                  <option value="">--Select Option--</option>
                  <option value="approve-and-assign">Approve and Assign</option>
                  <option value="reject">Reject</option>
                </select>
              </div>
            )}
          {data.status == "application-pending" && (
            <div>
              <select
                className="form-select form-select-sm"
                aria-label="Small select example"
                style={{
                  border: "1px solid rgba(212, 175, 55, 0.25)",
                  background: "rgba(18, 18, 18, 0.65)",
                  color: "#FFE082",
                  boxShadow: "none",
                }}
                onChange={(e) =>
                  handleSubStatusDropdownChange(e.target.value, data)
                }
                value={data.subStatus}
              >
                <option value="">--Select Option--</option>
                <option value="missing-documents">Missing Documents</option>
                <option value="payment-pending">Payment Pending</option>
                <option value="payment-successful">Payment Successful</option>
                <option value="application-submitted">
                  Application Submitted
                </option>
              </select>
            </div>
          )}
        </div>
      ),
    },
    // {
    //   title: "comment",
    //   dataIndex: "data",
    //   key: "key",
    //   render: (text, record) => (
    //     <div>
    //       <Button type="link" onClick={(e) => showModal(record.applicationId)}>
    //         Comment <i className="fa-regular fa-message"></i>
    //       </Button>
    //     </div>
    //   ),
    // },
    {
      title: "More Options",
      key: "actions",
      render: (text, data) => (
        <Space size="middle">
          <Link
            to={{
              pathname: "/chatsupport",
              state: { applicationDetails: data },
            }}
          >
            <div className="chatcontainer chatcss">
              Chat <i className="fa-regular fa-message"></i>
            </div>
          </Link>
          {loginUserRole === "admin" && (
            <div>
              <div>
                <select
                  className="form-select form-select-sm"
                  aria-label="Small select example"
                  style={{
                    border: "1px solid rgba(212, 175, 55, 0.25)",
                    background: "rgba(18, 18, 18, 0.65)",
                    color: "#FFE082",
                    boxShadow: "none",
                  }}
                  onChange={(e) => assigntoTeam(data, e.target.value)}
                >
                  <option>--Select Team--</option>
                  {teamsdata &&
                    teamsdata?.map((team) => (
                      <option
                        key={team.id}
                        value={team.id}
                        selected={data.teamId == team.id}
                      >
                        {team.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          )}

          {loginUserRole === "application-assistant" && (
            <div className="d-flex gap-1">
              <div className="editcontiner">
                <i className="fa-regular fa-pen-to-square"></i>
              </div>
              <div className="moreconatiner">...</div>
            </div>
          )}
        </Space>
      ),
    },
  ];

  const data = (tabledata || []).map((element) => ({
    id: element.id,
    applicationId: element.applicationId,
    createdDate: element.createdDate,
    masterDataEntityId: element.masterDataEntityId,
    status: element.status,
    subStatus: element.subStatus,
    name: element.name,
    university: element.university,
    intakes: element.intakes,
    updatedDate: element.updatedDate,
    firstName: element.firstName,
    lastName: element.lastName,
    userId: element.userId,
    teamId: element.teamId,
    year: element.year,
    imageUrl: element.imageUrl,
  }));

  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  const [table1, setTable1] = useState({
    ApplicationSubmitted: false,
    MissingDocuments: false,
    PaymentPending: false,
    PaymentSuccessful: false,
  });
  const handleFirstDropdownChange = (value, data) => {
    console.log("status is changed-->", value);
    const updatedStatus = {
      ...tableDataStatus,
      [data.id]: {
        showApplicationPending: value === "application-requested",
        showSecondDropdown: value === "application-pending",
      },
    };
    setTableDataStatus(updatedStatus);

    console.log("data is-->", data);
    updateDataAndTable(value, data);
  };
  const [valueAndDataInfo, setvalueAndDataInfo] = useState();
  const handleSubStatusDropdownChange = (value, data) => {
    console.log("sub-status is changed-->", value);
    console.log("sub-status data is changed-->", data);
    data.updatedDate = new Date().toISOString().split("T")[0];

    if (data) {
      if (["missing-documents", "reject"].includes(value)) {
        showModal(data.applicationId);
        setvalueAndDataInfo({value,data});
      } else {
        const updateData = createUpdatedSubStatusData(value, data);
        console.log("data for update information==>", updateData);
        updateApplication(updateData.id, updateData).then((response) => {
          const updatedData = updateTableData(response.data);
          parentDataUpdating(updatedData);
          settabledata(updatedData);
        });
      }
    } else {
      console.error("Error: 'data' is null or undefined.");
    }
  };
  const commentSentStatus = () => {
    const updateData = createUpdatedSubStatusData(valueAndDataInfo.value, valueAndDataInfo.data);
    console.log("data for update information==>", updateData);
    updateApplication(updateData.id, updateData).then((response) => {
      const updatedData = updateTableData(response.data);
      parentDataUpdating(updatedData);
      settabledata(updatedData);
    });
  };

  const updateDataAndTable = (value, data) => {
    data.updatedDate = new Date().toISOString().split("T")[0];
    console.log("Data before update==>", data);
    if (data) {
      const updateData = createUpdatedStatusData(value, data);

      updateApplication(updateData.id, updateData).then((response) => {
        const updatedData = updateTableData(response.data);
        console.log("data for update information==>", updateData);
        parentDataUpdating(updatedData);
        settabledata(updatedData);
      });
    } else {
      console.error("Error: 'data' is null or undefined.");
    }
  };

  const createUpdatedStatusData = (value, data) => {
    return {
      id: data.id,
      applicationId: data.applicationId,
      status: value,
      subStatus: null,
      intake: data.intakes,
      year: data.year,
      createdDate: data.createdDate,
      updatedDate: data.updatedDate,
      masterDataEntityId: data.masterDataEntityId,
      teamId: data.teamId,
      userId: data.userId,
    };
  };
  const createUpdatedSubStatusData = (value, data) => {
    return {
      id: data.id,
      applicationId: data.applicationId,
      status: data.status,
      subStatus: value,
      intake: data.intakes,
      year: data.year,
      createdDate: data.createdDate,
      updatedDate: data.updatedDate,
      masterDataEntityId: data.masterDataEntityId,
      teamId: data.teamId,
      userId: data.userId,
    };
  };

  const updateTableData = (response) => {
    return (tabledata || []).map((element) => {
      console.log("Response to the updateTable data==>", response);
      console.log("Response to the table data ==>", element);
      if (element && element.id === response.id) {
        return {
          ...element,
          applicationId: response.applicationId,
          status: response.status,
          subStatus: response.subStatus,
          intake: response.intake,
          year: response.year,
          name: element.name,
          createdDate: response.createdDate,
          updatedDate: response.updatedDate,
          masterDataEntityId: response.masterDataEntityId,
          teamId: response.teamId,
          userId: response.userId,
        };
      } else {
        return element;
      }
    });
  };

  return (
    <div>
     {loading && <Loading/>}
      <Table
        pagination={false}
        columns={columns}
        dataSource={data}
        onChange={onChange}
      /> 
      {isPopupVisible && (
        <App
          isPopupVisible={isPopupVisible}
          showModal={showModal}
          applicationId={popupApplicationId}
          handleOk={handleOk}
          handleCancel={handleCancel}
          commentSentStatus={commentSentStatus}
        />
      )}
    </div>
  );
}
